export const ADD_MAP_INFO_SUCCESS = 'ADD_MAP_INFO_SUCCESS';



export const FETCH_PARTNERS = 'MAP/FETCH_PARTNERS';
export const GET_DEEPLINK = 'GET_DEEPLINK';

export const SET_SELECTED_ADDRESS_ID = 'SET_SELECTED_ADDRESS_ID';
